/**
 * Shared keyframe styles for the .reveal scroll-animation pattern.
 * Render once at the bottom of any page using useReveal().
 */
const RevealStyles = () => (
  <style>{`
    .reveal { opacity: 0; transform: translateY(30px); transition: opacity 0.8s ease, transform 0.8s ease; }
    .reveal.animate-in { opacity: 1; transform: translateY(0); }
  `}</style>
);

export default RevealStyles;
